<!-- ####################################################### Products -->
<template>
  <div class="w-full" style="">
    <div v-if="am_allowed('product.can_see_product')">
      <div class="mx-0 columns" :class="{ 'half-height mb-0 overfllow-y-scroll-mobile': selected_item.id }">
        <div class="pb-0 overflow-auto column is-flex is-flex-direction-column" :class="{ 'overfllow-y-scroll': selected_item.id }">
          <product-grid-toolbar
            :column-defs="columnDefs.filter((f) => !['actions'].includes(f.field))"
            :hiden_columns="hiden_columns"
            :search="global_search_filter"
            :filters="grid_filters"
            :pinned-codes="pinned_codes"
            :per-page="grid_per_page"
            :loading="grid_loading"
            :total-rows="grid_total"
            :current-page="current_page"
            :column-labels="gridColumnLabels"
            :can-create="am_allowed('product.can_create_product')"
            :attributes-export-loading="attributesExportLoading"
            :grid-export-loading="gridExportLoading"
            @toggle_column="toggle_column"
            @update:search="onGlobalSearchUpdate"
            @update:perPage="onPerPageChange"
            @quick-filter="onQuickFilter"
            @toggle-offer="onToggleOfferFilter"
            @toggle-new-codes="onToggleNewCodesFilter"
            @toggle-edited-codes="onToggleEditedCodesFilter"
            @date-range="onDateRangeFilter"
            @remove-filter="onRemoveFilter"
            @clear-filters="onClearFilters"
            @pin-search="onPinSearchCode"
            @select-suggestion="onSelectSuggestion"
            @open-services="openModal('services')"
            @open-brands="show_brands_krudh('brands')"
            @online-health="show_online_health_modal = true"
            @system-health="show_system_health_modal = true"
            @import-labels="showLabelImportModal = true"
            @import-bulk-codes="showBulkCodeImportModal = true"
            @export-grid="exportFilteredGrid"
            @export-attributes="exportProductAttributes"
            @create="create_product"
          />
          <div class="overflow-x-scroll is-flex-grow-1">
            <dable
              v-if="rowData.value && columnDefs"
              ref="productGrid"
              :headers="columnDefs"
              :data="rowData.value"
              :entity="'product'"
              :hidden_columns="hiden_columns"
              :currPage="current_page"
              :serverMode="true"
              :totalRows="grid_total"
              :pageSize="grid_per_page"
              :serverFilters="grid_filters"
              :sort-field="grid_sort_field"
              :sort-dir="grid_sort_dir"
              :loading="grid_loading"
              :save-loading="group_change_saving"
              layout-storage-key="product-grid-v2"
              @save-changes="save_changes"
              @page-change="onGridPageChange"
              @query-change="onGridQueryChange"
              @pin-code="onPinCode"
            />
          </div>
        </div>
        <div
          :class="{ 'overfllow-y-scroll': selected_item.id }"
          class="border-b column is-5 sticky-form"
          id="product-form-containers"
          v-if="form_edit || form_create || form_create_product_recipe || form_edit_product_recipe"
        >
          <DaForm v-if="form_create" @submitted="submitProduct" :form="form_create" @close="form_create = null" :closes_form="true" :saving="productSaving" :is_overflow="selected_item.id ? true : false"> </DaForm>

          <template v-if="form_edit">
            <div v-if="canSeeProductFormHistory" class="tabs is-boxed is-size-7 product-form-tabs mb-0">
              <ul>
                <li :class="{ 'is-active': productFormTab === 'form' }">
                  <a @click.prevent="productFormTab = 'form'">Produkti</a>
                </li>
                <li :class="{ 'is-active': productFormTab === 'history' }">
                  <a @click.prevent="productFormTab = 'history'">Historik</a>
                </li>
              </ul>
            </div>
            <DaForm
              v-show="productFormTab === 'form' || !canSeeProductFormHistory"
              @submitted="submitProduct"
              :form="form_edit"
              @close="form_edit = null"
              :closes_form="true"
              :saving="productSaving"
              :is_overflow="selected_item.id ? true : false"
            />
            <div v-if="productFormTab === 'history' && canSeeProductFormHistory" class="product-form-history px-2 pb-3">
              <product-history-tab :guid="formEditGuid" :reload-key="historyReloadKey" :compact="true" />
            </div>
          </template>

          <table v-if="form_create_product_recipe || form_edit_product_recipe" class="table is-fullwidth">
            <thead>
              <tr>
                <th>Produkti</th>
                <th>Materiali</th>
                <th>Sasia</th>
                <th>Njesia</th>
                <th>Modifiko</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="product_recipe in product_recipes" :key="product_recipe.id">
                <td>{{ product_recipe.product_name }}</td>
                <td>{{ product_recipe.material_name }}</td>
                <td>{{ product_recipe.quantity }}</td>
                <td>{{ product_recipe.unit_name }}</td>
                <td>
                  <a @click.prevent="edit_product_recipe(product_recipe)">
                    <i class="fa fa-pencil"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <DaForm v-if="form_create_product_recipe" @submitted="submitProductRecipe" @close="form_create_product_recipe = null" :closes_form="true" :form="form_create_product_recipe"> </DaForm>

          <DaForm v-if="form_edit_product_recipe" @submitted="submitProductRecipe" @close="form_edit_product_recipe = null" :closes_form="true" :form="form_edit_product_recipe"> </DaForm>
        </div>
      </div>

      <div v-if="selected_item.id" class="pt-2 mt-4 border-t-2 border-slate-200">
        <div class="is-flex">
          <a @click.prevent="close_selected_item()" href="" class="mb-2 ml-auto mr-2 delete is-small"></a>
        </div>
        <div class="columns">
          <div class="column is-4">
            <product-details :selected_item="selected_item" :attributes_per_item="attributes_per_item" @resynced="onProductFinancaResynced"></product-details>
          </div>
          <div class="column is-8">
            <div class="">
              <div class="tabs is-fullwidth is-boxed is-size-7">
                <ul>
                  <li :class="{ 'is-active': show_tab == 1 }">
                    <a @click.prevent="show_tab = 1">Ditare</a>
                  </li>
                  <li :class="{ 'is-active': show_tab == 2 }">
                    <a @click.prevent="show_tab = 2">Porosi</a>
                  </li>
                  <li :class="{ 'is-active': show_tab == 3 }">
                    <a @click.prevent="show_tab = 3">Gjendje</a>
                  </li>
                  <li v-if="am_allowed('product.can_see_product_history')" :class="{ 'is-active': show_tab == 4 }">
                    <a @click.prevent="show_tab = 4">Historik</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="px-2" style="border: solid 1px #dbdbdb; border-width: 0px 1px">
              <div v-if="show_tab == 1">
                <product-diary-tab :guid="selected_item.guid"></product-diary-tab>
              </div>
              <div v-if="show_tab == 2">
                <product-process-tab :guid="selected_item.guid"></product-process-tab>
              </div>
              <div v-if="show_tab == 3">
                <product-stock v-if="show_tab == 3" :product="selected_item"></product-stock>
              </div>
              <div v-if="show_tab == 4 && am_allowed('product.can_see_product_history')">
                <product-history-tab :guid="selected_item.guid"></product-history-tab>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="group_change_saving" class="group-change-loading" aria-live="polite">
        <div class="group-change-loading__box">
          <i class="fa fa-spinner fa-spin"></i>
          <span>Duke ruajtur ndryshimet dhe duke i dërguar në Financa...</span>
        </div>
      </div>

    </div>

    <online-sync-health-modal v-if="show_online_health_modal" @close="show_online_health_modal = false" />
    <system-sync-health-modal v-if="show_system_health_modal" @close="show_system_health_modal = false" />

    <LabelCodeImportModal
      :open="showLabelImportModal"
      @close="showLabelImportModal = false"
      @resolved="onLabelCodesResolved"
    />
    <ProductBulkImportModal
      :open="showBulkCodeImportModal"
      @close="showBulkCodeImportModal = false"
      @applied="onBulkImportApplied"
    />
    <LabelExportModal
      :open="showLabelExportModal"
      :loading="labelExportLoading"
      :export-context="labelImportExportContext"
      :mode="labelExportModalMode"
      :notice-product-count="labelImportGuids.length"
      title="Eksporto etiketat (PDF)"
      subtitle="Nga skedari i kodeve"
      @close="closeLabelImportExportModal"
      @confirm="confirmLabelImportExport"
    />
  </div>
</template>

<script>
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
// import { AgGridVue } from "ag-grid-vue3";
import DaForm from "@/components/daform/index.vue";
// import ButtonsCell from "@/components/buttonscell/ButtonsCell.vue";
import createProduct from "./forms/product form/create";
import editProduct from "./forms/product form/edit";
import createProductRecipe from "./forms/product-recipe form/create_product_recipe";
import editProductRecipe from "./forms/product-recipe form/edit_product_recipe";
import { clearProductFormLookupsCache } from "@/services/productFormLookups";
import locale from "@/components/ag-grid/locale/al/al.js";
import CategoriesServices from "@/services/Category";
import ProductsServices from "@/services/Product";
import { financaBulkFailureText, productFinancaSaveNotice } from "@/utils/financaSaveNotice";
// import productTransactionsReport from "./components/product-transactions-report";
import productDiaryTab from "./components/product-diary-tab";
import productProcessTab from "./components/product-process-tab";
import productDetails from "./components/product-details";
import productStock from "./components/product-stock";
import productHistoryTab from "./components/product-history-tab";
import socket from "@/socket.js";
import { onUnmounted, reactive, inject } from "vue";
import permissionMixin from "@/mixins/permissions-mixin.js";
import { defineAsyncComponent } from "vue";
import { $vfm } from "vue-final-modal";
var numeral = require("numeral");
import Api from "@/services/Api";
import dable from "@/components/Dable.vue";
import productGridToolbar from "./components/product-grid-toolbar.vue";
import ProductServices from "@/services/Product";
import onlineSyncHealthModal from "./components/online-sync-health-modal.vue";
import systemSyncHealthModal from "./components/system-sync-health-modal.vue";
import LabelCodeImportModal from "@/components/LabelCodeImportModal.vue";
import ProductBulkImportModal from "./components/ProductBulkImportModal.vue";
import LabelExportModal from "@/components/LabelExportModal.vue";
import WarehousesServices from "@/services/Warehouse";
// import { $vfm } from 'vue-final-modal'
// import ConfigurationService from "@/services/Configuration.js"
// import { useKrudhStore } from "@/stores/krudh_communication";
// import { storeToRefs } from "pinia";

export default {
  mixins: [permissionMixin],
  components: {
    // AgGridVue,
    DaForm,
    // productTransactionsReport,
    productDetails,
    productStock,
    productHistoryTab,
    dable,
    productGridToolbar,
    onlineSyncHealthModal,
    systemSyncHealthModal,
    productDiaryTab,
    productProcessTab,
    LabelCodeImportModal,
    ProductBulkImportModal,
    LabelExportModal,
    // ButtonsCell,
  },
  setup() {
    let rowData = reactive([]);
    const toast = inject("toast");
    socket.connect();
    socket.on("welcome", (data) => {
      console.log("welcome", data);
    });
    socket.on("propagate", (data) => {
      if (data.entity == "products") {
        if (data.action == "create") {
          var a = rowData.value;
          a.push(data.data);
          rowData.value = [...a];
          toast.success("Produkti u krijua <i>nga " + data.created_by.name + "</i>");
        }
        if (data.action == "edit") {
          rowData.value = [
            ...rowData.value.map((item) => {
              if (item.id == data.data.id) {
                return data.data;
              }
              return item;
            }),
          ];
          toast.success("Produkti u modifikua <i>nga " + data.created_by.name + "</i>");
        }
        if (data.action == "delete") {
          rowData.value = [
            ...rowData.value.filter((item) => {
              return item.id != data.data.id;
            }),
          ];
        }
      }
    });
    onUnmounted(() => {
      socket.off("welcome");
      socket.off("propagate");
      socket.disconnect();
    });
    return {
      rowData,
    };
  },
  beforeMount() {
    this.context = { componentParent: this };
  },
  data() {
    return {
      global_search_filter: "",
      pinned_codes: [],
      grid_filters: {},
      grid_sort_field: "name",
      grid_sort_dir: "asc",
      grid_total: 0,
      grid_per_page: 50,
      grid_loading: false,
      search_debounce_timer: null,
      show_online_health_modal: false,
      show_system_health_modal: false,
      showLabelImportModal: false,
      showBulkCodeImportModal: false,
      showLabelExportModal: false,
      labelExportLoading: false,
      labelExportModalMode: "export",
      labelImportGuids: [],
      attributesExportLoading: false,
      gridExportLoading: false,
      service_types_list: [],
      services_eav_data: [],
      context: null,
      current_page: 1,
      is_product_recipe: "",
      product_recipes: [],
      selectedProduct: {},
      selectedProductRecipe: {},
      form_create_product_recipe: null,
      form_edit_product_recipe: null,
      form_create: null,
      form_edit: null,
      productFormTab: "form",
      historyReloadKey: 0,
      productSaving: false,
      // rowData   : [],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        // flex: 1,
        // minWidth: 400,
      },
      rowSelection: "single",
      localeText: null,
      show_tab: 1,
      selected_item: {},
      attributes_per_item: {},
      services_per_item: {},
      show_services_col: true,
      hiden_columns: [],
      managers: [],
      origin_countries: [],
      warranties: [],
      brandFilterOptions: [],
      categoryPaths: [],
      categoryPathsLoaded: false,
      categoryFilterOptions: { level1: [], level2: [], level4: [] },
      group_change_saving: false,
      warehouses_list: [],
    };
  },
  methods: {
    onLabelCodesResolved({ guids, missing }) {
      this.showLabelImportModal = false;
      this.labelImportGuids = Array.isArray(guids) ? [...guids] : [];
      if (!this.labelImportGuids.length) {
        this.$toast.error("Asnjë kod nga skedari nuk u gjet në katalog.");
        return;
      }
      if (missing?.length) {
        this.$toast.warning(`${missing.length} kode nuk u gjetën. Do të eksportohen ${this.labelImportGuids.length} produkte.`);
      }
      this.labelExportModalMode = "export";
      this.showLabelExportModal = true;
    },
    async onBulkImportApplied(result) {
      const updated = result?.updated || 0;
      const failed = result?.failed || 0;
      const skippedReason = result?.skipped_reason_count || result?.skipped_rows?.length || 0;
      if (updated > 0) {
        await this.loadGridPage();
      }
      if (failed) {
        this.$toast.warning(`U përditësuan ${updated} produkte. ${failed} rreshta dështuan.`);
      } else if (skippedReason && updated > 0) {
        this.$toast.warning(`U përditësuan ${updated} produkte. ${skippedReason} u anashkaluan (fushat mandatore s'janë plotësuar).`);
      } else if (skippedReason) {
        this.$toast.warning(`${skippedReason} rreshta u anashkaluan. Fushat mandatore s'janë plotësuar.`);
      } else if (updated > 0) {
        this.$toast.success(`U përditësuan ${updated} produkte nga Excel.`);
      } else {
        this.$toast.info("Nuk u aplikua asnjë ndryshim.");
      }
    },
    closeLabelImportExportModal() {
      if (this.labelExportLoading) return;
      this.showLabelExportModal = false;
      this.labelExportModalMode = "export";
      this.labelImportGuids = [];
    },
    async confirmLabelImportExport({ per_page }) {
      if (!this.labelImportGuids.length) return;
      this.labelExportLoading = true;
      try {
        await ProductsServices.exportLabels({
          product_guids: this.labelImportGuids,
          related_entity: "products",
          include_descendants: false,
          per_page,
        });
        this.$toast.success("PDF i etiketave u shkarkua.");
        this.showLabelExportModal = false;
        this.labelImportGuids = [];
      } catch (e) {
        this.$toast.error(e?.message || "Nuk u shkarkua PDF i etiketave.");
      } finally {
        this.labelExportLoading = false;
      }
    },
    async exportProductAttributes() {
      if (this.attributesExportLoading) return;
      this.attributesExportLoading = true;
      try {
        await ProductsServices.exportProductAttributes({
          search: this.pinned_codes.length ? "" : this.global_search_filter.trim(),
          filters: this.buildGridFilters(),
          product_codes: this.pinned_codes.length ? [...this.pinned_codes] : null,
        });
        this.$toast.success("Eksporti i atributeve u shkarkua.");
      } catch (e) {
        this.$toast.error(e?.response?.data?.message || e?.message || "Nuk u shkarkua eksporti i atributeve.");
      } finally {
        this.attributesExportLoading = false;
      }
    },
    async exportFilteredGrid() {
      if (this.gridExportLoading) return;
      if (!this.grid_total) {
        this.$toast.error("Nuk ka produkte për eksport me filtrat aktualë.");
        return;
      }
      this.gridExportLoading = true;
      try {
        await ProductsServices.exportGridCsv({
          search: this.pinned_codes.length ? "" : this.global_search_filter.trim(),
          filters: this.buildGridFilters(),
          product_codes: this.pinned_codes.length ? [...this.pinned_codes] : null,
          sort_field: this.grid_sort_field,
          sort_dir: this.grid_sort_dir,
        });
        this.$toast.success(`Eksporti i ${this.grid_total} produkteve të filtruar u shkarkua.`);
      } catch (e) {
        this.$toast.error(e?.response?.data?.message || e?.message || "Nuk u shkarkua eksporti i produkteve.");
      } finally {
        this.gridExportLoading = false;
      }
    },
    groupChangeErrorMessage(e) {
      const payload = e?.response?.data;
      if (typeof payload === "string" && payload.trim() && !payload.trim().startsWith("<")) {
        return payload.slice(0, 240);
      }
      if (payload && typeof payload === "object") {
        const fromObject = payload.message || payload.error;
        if (fromObject) return String(fromObject).slice(0, 240);
      }
      if (e?.message === "Network Error") return "Nuk u lidh me serverin. Provoni përsëri.";
      if (e?.message) return e.message;
      return "Nuk u ruajtën ndryshimet.";
    },
    async save_changes(products) {
      if (this.group_change_saving) return;
      const count = products && typeof products === "object" ? Object.keys(products).length : 0;
      if (!count) {
        this.$toast.info("Nuk ka ndryshime për të ruajtur.");
        return;
      }
      this.group_change_saving = true;
      try {
        const res = await Api(true).post("product/save/changes", {
          products,
          reason_text: "Ndryshim në grup",
          change_type: 1,
        });
        const data = res.data;
        const updated = Array.isArray(data) ? data.length : (data?.updated ?? count);
        const financaFailed = Array.isArray(data) ? 0 : (data?.financa_failed || 0);
        const financaSynced = Array.isArray(data) ? 0 : (data?.financa_synced || 0);
        if (financaFailed) {
          const codes = (data?.financa_failed_sync || [])
            .map((row) => row?.code)
            .filter(Boolean)
            .slice(0, 3)
            .join(", ");
          const detail = financaBulkFailureText(data?.financa_failed_sync);
          this.$toast.warning(
            `U ruajtën ${updated} produkte. ${detail || `${financaFailed} nuk u shkruan në Financa`}${codes ? ` (${codes})` : ""}.`
          );
        } else if (financaSynced) {
          this.$toast.success(`U ruajtën ndryshimet për ${updated} produkte. U ruajtën në Financa 1 dhe Financa 2.`);
        } else {
          this.$toast.success(`U ruajtën ndryshimet për ${updated} produkte.`);
        }
        this.$refs.productGrid?.clearSelection?.();
        await this.loadGridPage();
      } catch (e) {
        this.$toast.error(this.groupChangeErrorMessage(e));
      } finally {
        this.group_change_saving = false;
      }
    },
    toggle_column(column) {
      if (this.hiden_columns.includes(column)) {
        this.hiden_columns = [...this.hiden_columns.filter((item) => item != column)];
      } else {
        this.hiden_columns.push(column);
      }
      // Save localstorave
      localStorage.removeItem("hiden_columns");
      localStorage.hiden_columns = JSON.stringify(this.hiden_columns);

      // setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 100);
    },
    buildGridFilters() {
      const filters = { ...this.grid_filters };
      delete filters.code;
      delete filters.codes;
      return filters;
    },
    normalizeFilterList(value) {
      if (Array.isArray(value)) return value.map((v) => String(v).trim()).filter(Boolean);
      if (value == null || value === "") return [];
      return [String(value).trim()].filter(Boolean);
    },
    buildCategoryPaths(flatList) {
      const byId = new Map();
      (flatList || []).forEach((c) => {
        if (c?.guid) byId.set(String(c.guid), c);
      });
      const paths = [];
      byId.forEach((node) => {
        const names = [];
        const seen = new Set();
        let cur = node;
        while (cur && cur.guid && !seen.has(cur.guid)) {
          seen.add(cur.guid);
          const name = String(cur.name || "").trim();
          if (name) names.unshift(name);
          const pid = cur.parent_id ? String(cur.parent_id).trim() : "";
          cur = pid ? byId.get(pid) : null;
        }
        if (!names.length) return;
        paths.push({
          l1: names[0] || "",
          l2: names.length >= 2 ? names[1] : "",
          group: names.length >= 4 ? names[3] : names[names.length - 1],
        });
      });
      return paths;
    },
    toFilterOptions(names) {
      const unique = [...new Set((names || []).filter(Boolean))];
      unique.sort((a, b) => a.localeCompare(b, "sq", { sensitivity: "base" }));
      return unique.map((name) => ({ value: name, label: name }));
    },
    async loadBrandFilterOptions() {
      try {
        const brands = await ProductsServices.getBrands();
        this.brandFilterOptions = this.toFilterOptions((brands || []).map((b) => b.name || b.label));
      } catch (e) {
        this.brandFilterOptions = [];
      }
    },
    computeCategoryFilterOptions() {
      const level1 = this.normalizeFilterList(this.grid_filters.category_level_1);
      const level2 = this.normalizeFilterList(this.grid_filters.category_level_2);
      const l1Set = new Set(level1);
      const l2Set = new Set(level2);
      const l1Names = [];
      const l2Names = [];
      const groupNames = [];
      this.categoryPaths.forEach((p) => {
        if (p.l1) l1Names.push(p.l1);
        const matchesL1 = !l1Set.size || l1Set.has(p.l1);
        if (matchesL1 && p.l2) l2Names.push(p.l2);
        const matchesL2 = !l2Set.size || l2Set.has(p.l2);
        if (matchesL1 && matchesL2 && p.group) groupNames.push(p.group);
      });
      return {
        level1: this.toFilterOptions(l1Names),
        level2: this.toFilterOptions(l2Names),
        level4: this.toFilterOptions(groupNames),
      };
    },
    pruneInvalidCategoryFilters() {
      const validL2 = new Set(this.categoryFilterOptions.level2.map((o) => o.value));
      const validL4 = new Set(this.categoryFilterOptions.level4.map((o) => o.value));
      const next = { ...this.grid_filters };
      let changed = false;
      if (Array.isArray(next.category_level_2)) {
        const pruned = next.category_level_2.filter((v) => validL2.has(v));
        if (pruned.length !== next.category_level_2.length) {
          if (pruned.length) next.category_level_2 = pruned;
          else delete next.category_level_2;
          changed = true;
        }
      }
      if (Array.isArray(next.category_product_group)) {
        const pruned = next.category_product_group.filter((v) => validL4.has(v));
        if (pruned.length !== next.category_product_group.length) {
          if (pruned.length) next.category_product_group = pruned;
          else delete next.category_product_group;
          changed = true;
        }
      }
      if (changed) this.grid_filters = next;
    },
    async syncCategoryFilterOptions() {
      if (!this.categoryPathsLoaded) {
        try {
          const [products, accessories] = await Promise.all([
            CategoriesServices.getCategories("products"),
            CategoriesServices.getCategories("accessories"),
          ]);
          this.categoryPaths = this.buildCategoryPaths([...(products || []), ...(accessories || [])]);
        } catch (e) {
          this.categoryPaths = [];
        }
        this.categoryPathsLoaded = true;
      }

      if (this.categoryPaths.length) {
        this.categoryFilterOptions = this.computeCategoryFilterOptions();
        this.pruneInvalidCategoryFilters();
        return;
      }

      const level1 = this.normalizeFilterList(this.grid_filters.category_level_1);
      const level2 = this.normalizeFilterList(this.grid_filters.category_level_2);
      try {
        const data = await ProductsServices.getCategoryFilterOptions({ level1, level2 });
        this.categoryFilterOptions = {
          level1: data.level1 || [],
          level2: data.level2 || [],
          level4: data.level4 || [],
        };
      } catch (e) {
        this.categoryFilterOptions = { level1: [], level2: [], level4: [] };
      }
      this.pruneInvalidCategoryFilters();
    },
    normalizePinnedCode(code) {
      return String(code ?? "").trim();
    },
    hasPinnedCode(code) {
      const normalized = this.normalizePinnedCode(code).toLowerCase();
      return this.pinned_codes.some((c) => c.toLowerCase() === normalized);
    },
    clearColumnCodeFilter() {
      const next = { ...this.grid_filters };
      delete next.code;
      delete next.codes;
      this.grid_filters = next;
    },
    onPinSearchCode() {
      if (this.search_debounce_timer) clearTimeout(this.search_debounce_timer);
      this.current_page = 1;
      this.loadGridPage();
    },
    async onSelectSuggestion(item) {
      if (!item?.guid) {
        const code = this.normalizePinnedCode(item?.code);
        if (code) this.onPinCode(code);
        return;
      }

      this.global_search_filter = "";
      if (this.search_debounce_timer) clearTimeout(this.search_debounce_timer);

      await this.open("1", item);

      this.$nextTick(() => {
        setTimeout(() => {
          const productFormContainers = document.getElementById("product-form-containers");
          if (productFormContainers) {
            productFormContainers.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 150);
      });
    },
    onPinCode(code) {
      const trimmed = this.normalizePinnedCode(code);
      if (!trimmed) return;
      if (!this.hasPinnedCode(trimmed)) {
        this.pinned_codes = [...this.pinned_codes, trimmed];
      }
      this.global_search_filter = "";
      if (this.search_debounce_timer) clearTimeout(this.search_debounce_timer);
      this.clearColumnCodeFilter();
      this.current_page = 1;
      this.loadGridPage();
    },
    onGlobalSearchUpdate(value) {
      this.global_search_filter = value;
      this.onSearchInput();
    },
    onSearchInput() {
      if (this.pinned_codes.length > 0) {
        return;
      }
      if (this.search_debounce_timer) {
        clearTimeout(this.search_debounce_timer);
      }
      this.search_debounce_timer = setTimeout(() => {
        this.current_page = 1;
        this.loadGridPage();
      }, 300);
    },
    onPerPageChange(perPage) {
      this.grid_per_page = perPage;
      this.current_page = 1;
      this.loadGridPage();
    },
    onQuickFilter({ field, value }) {
      const next = { ...this.grid_filters };
      if (value === "" || value == null || next[field] === value) delete next[field];
      else next[field] = value;
      this.grid_filters = next;
      this.current_page = 1;
      this.loadGridPage();
    },
    defaultDateRange() {
      const to = new Date();
      const from = new Date();
      from.setDate(from.getDate() - 7);
      const fmt = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
      };
      return { from: fmt(from), to: fmt(to) };
    },
    defaultNewCodesRange() {
      const range = this.defaultDateRange();
      return { created_from: range.from, created_to: range.to };
    },
    defaultEditedCodesRange() {
      const range = this.defaultDateRange();
      return { updated_from: range.from, updated_to: range.to };
    },
    onToggleOfferFilter(enable) {
      const next = { ...this.grid_filters };
      if (enable) next.on_offer = "1";
      else delete next.on_offer;
      this.grid_filters = next;
      this.current_page = 1;
      this.loadGridPage();
    },
    onToggleNewCodesFilter(enable) {
      const next = { ...this.grid_filters };
      if (enable) {
        const range = this.defaultNewCodesRange();
        next.new_codes = "1";
        next.created_from = range.created_from;
        next.created_to = range.created_to;
      } else {
        delete next.new_codes;
        delete next.created_from;
        delete next.created_to;
      }
      this.grid_filters = next;
      this.current_page = 1;
      this.loadGridPage();
    },
    onToggleEditedCodesFilter(enable) {
      const next = { ...this.grid_filters };
      if (enable) {
        const range = this.defaultEditedCodesRange();
        next.edited_codes = "1";
        next.updated_from = range.updated_from;
        next.updated_to = range.updated_to;
      } else {
        delete next.edited_codes;
        delete next.updated_from;
        delete next.updated_to;
      }
      this.grid_filters = next;
      this.current_page = 1;
      this.loadGridPage();
    },
    onDateRangeFilter({ field, value }) {
      const createdFields = field === "created_from" || field === "created_to";
      const updatedFields = field === "updated_from" || field === "updated_to";
      if (!createdFields && !updatedFields) return;
      const next = {
        ...this.grid_filters,
        [field]: value || "",
        ...(createdFields ? { new_codes: "1" } : { edited_codes: "1" }),
      };
      if (!next[field]) delete next[field];
      this.grid_filters = next;
      this.current_page = 1;
      this.loadGridPage();
    },
    onRemoveFilter(key) {
      if (key === "__search__") {
        this.global_search_filter = "";
      } else if (String(key).startsWith("code:")) {
        const code = key.slice(5);
        this.pinned_codes = this.pinned_codes.filter((c) => c.toLowerCase() !== code.toLowerCase());
        this.clearColumnCodeFilter();
      } else if (key === "new_codes" || key === "created_from" || key === "created_to") {
        const next = { ...this.grid_filters };
        delete next.new_codes;
        delete next.created_from;
        delete next.created_to;
        this.grid_filters = next;
      } else if (key === "edited_codes" || key === "updated_from" || key === "updated_to") {
        const next = { ...this.grid_filters };
        delete next.edited_codes;
        delete next.updated_from;
        delete next.updated_to;
        this.grid_filters = next;
      } else {
        const next = { ...this.grid_filters };
        delete next[key];
        this.grid_filters = next;
      }
      this.current_page = 1;
      this.syncCategoryFilterOptions().then(() => this.loadGridPage());
    },
    onClearFilters() {
      this.global_search_filter = "";
      this.pinned_codes = [];
      this.grid_filters = {};
      this.current_page = 1;
      this.syncCategoryFilterOptions().then(() => this.loadGridPage());
    },
    onGridQueryChange({ filters, sortField, sortDir, page }) {
      const run = async () => {
        if (filters) {
          const next = { ...filters };
          if (this.pinned_codes.length) {
            delete next.code;
            delete next.codes;
          }
          this.grid_filters = next;
          await this.syncCategoryFilterOptions();
        }
        if (sortField) this.grid_sort_field = sortField;
        if (sortDir) this.grid_sort_dir = sortDir;
        if (page) this.current_page = page;
        this.loadGridPage();
      };
      run();
    },
    onGridPageChange(page) {
      this.current_page = page;
      this.loadGridPage();
    },
    async loadGridPage() {
      this.grid_loading = true;
      try {
        if (this.pinned_codes.length > 1) {
          const unified = await this.fetchGridPage({ page: 1, per_page: Math.max(this.grid_per_page, this.pinned_codes.length) });
          const looksUnfiltered = (unified.total || 0) > Math.max(100, this.pinned_codes.length * 5);
          if (!looksUnfiltered) {
            this.applyGridResult(unified);
            return;
          }
          const merged = await this.fetchGridPagePerPinnedCode();
          this.applyGridResult(merged);
          return;
        }

        const result = await this.fetchGridPage({
          page: this.current_page,
          per_page: this.grid_per_page,
        });
        this.applyGridResult(result);
      } catch (e) {
        this.$toast?.error?.("Gabim gjatë ngarkimit të produkteve.");
      } finally {
        this.grid_loading = false;
      }
    },
    fetchGridPage({ page, per_page }) {
      return ProductsServices.getProductsGrid({
        page,
        per_page,
        search: this.pinned_codes.length ? "" : this.global_search_filter.trim(),
        sort_field: this.grid_sort_field,
        sort_dir: this.grid_sort_dir,
        filters: this.buildGridFilters(),
        product_codes: this.pinned_codes.length ? [...this.pinned_codes] : null,
      });
    },
    async fetchGridPagePerPinnedCode() {
      const byGuid = new Map();
      let mergedEav = [];
      let serviceTypesList = null;

      for (const code of this.pinned_codes) {
        const result = await ProductsServices.getProductsGrid({
          page: 1,
          per_page: 5,
          sort_field: this.grid_sort_field,
          sort_dir: this.grid_sort_dir,
          filters: this.buildGridFilters(),
          product_codes: [code],
        });
        if (result.service_types_list && !serviceTypesList) {
          serviceTypesList = result.service_types_list;
        }
        mergedEav = mergedEav.concat(result.services_eav_data || []);
        (result.data || []).forEach((row) => {
          if (row?.guid) byGuid.set(row.guid, row);
        });
      }

      return {
        data: Array.from(byGuid.values()),
        total: byGuid.size,
        page: 1,
        per_page: this.grid_per_page,
        service_types_list: serviceTypesList,
        services_eav_data: mergedEav,
      };
    },
    applyGridResult(result) {
      if (result.service_types_list && !this.service_types_list.length) {
        this.service_types_list = result.service_types_list;
      }
      this.rowData.value = result.data || [];
      this.grid_total = result.total || 0;
      this.grid_per_page = result.per_page || this.grid_per_page;
    },
    async open(mode, product) {
      // edit mode
      if (mode == "1") {
        if (this.am_allowed("product.can_edit_product")) {
          this.form_create = null;
          this.form_create_product_recipe = null;
          this.form_edit_product_recipe = null;
          this.form_edit = null;
          this.productFormTab = "form";
          if (product) {
            this.selectedProduct = { ...product };
            this.form_edit = { loading: true };
            this.form_edit = await editProduct(product);
            // If screen width is smaller than 768px
            if (window.innerWidth < 768) {
              this.close_selected_item();
              // Scroll to form
              setTimeout(() => {
                const productFormContainers = document.getElementById("product-form-containers");
                if (productFormContainers) {
                  productFormContainers.scrollIntoView({ behavior: "smooth" });
                }
              }, 1000);
            }
            // setTimeout(() => {
            //   this.gridApi.sizeColumnsToFit();
            // }, 100);
          }
        } else {
          this.$toast.error("Nuk keni te drejta te modifikoni produktin.");
        }
      } else if (mode == "0") {
        if (this.am_allowed("product.can_see_product_details")) {
          // this.form_edit = null;
          // this.form_create = null;

          this.selected_item = {};
          this.selected_item = await ProductsServices.get({
            guid: product.guid,
          });
          // this.gridApi.sizeColumnsToFit();
          setTimeout(async () => {
            let selected_category = {};
            selected_category[product.is_accessory == 0 ? product.type_id : product.accessory_id] = true;
            this.attributes_per_item = await CategoriesServices.getCategoryAttributes(selected_category, product, true);

            // Get services categories ...
            this.services_per_item = await CategoriesServices.getCategoryAttributes(selected_category, product, true, "services");
          });
        } else {
          this.$toast.error("Nuk keni te drejta per te hapur te dhenat produktit.");
        }
      } else if (mode == "2") {
        // this.gridApi.sizeColumnsToFit();
        this.form_edit = null;
        this.form_edit_product_recipe = null;
        this.form_create = null;
        this.selectedProduct = {};
        this.product_recipes = await ProductsServices.getProductRecipes();
        var temp_pr = product;

        this.selectedProduct = temp_pr;
        this.form_create_product_recipe = { loading: true };
        this.form_create_product_recipe = await createProductRecipe();
      }
    },
    // onGridReady(params) {
    //   this.gridApi = params.api;
    //   this.gridApi.sizeColumnsToFit();
    //   this.gridColumnApi = params.columnApi;
    // },
    async create_product() {
      this.form_edit = null;
      this.form_edit_product_recipe = null;
      this.form_create_product_recipe = null;

      // setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 100);
      this.form_create = { loading: true };
      this.form_create = await createProduct();
      // setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 100);

      // AG Grid show less columns ...
    },
    async create_product_recipe() {
      this.form_edit = null;
      this.form_edit_product_recipe = null;
      this.form_create = null;
      this.form_create_product_recipe = { loading: true };
      this.form_create_product_recipe = await createProductRecipe();
      // this.gridApi.sizeColumnsToFit();
    },
    async edit_product_recipe(pr) {
      this.form_create_product_recipe = null;
      this.form_create = null;
      if (pr) {
        // this.gridApi.sizeColumnsToFit();
        this.form_edit_product_recipe = null;
        this.form_edit = null;
        this.form_edit_product_recipe = { loading: true };
        this.form_edit_product_recipe = await editProductRecipe(pr);
        this.selectedProductRecipe = pr;
      }
    },
    async submitProduct(p, close_on_submit = true, onAfterCreate = null, onDone = null) {
      if (this.productSaving) return;
      this.productSaving = true;

      // If product is inactive, warn before proceeding (for all submit buttons)
      const isInactive = p.status === 0 || p.status === "0";
      if (isInactive) {
        const proceed = window.confirm("Ky produkt është lënë jo aktiv. Dëshiron të vazhdosh?");
        if (!proceed) {
          this.productSaving = false;
          if (typeof onDone === "function") onDone();
          return;
        }
      }

      const createdNewLookup =
        p.is_new_supplier == 1 || p.is_new_supplier === "1" ||
        p.is_new_brand == 1 || p.is_new_brand === "1";

      try {
        let notify_text = "";
        if (this.form_create != null) {
          // 1. Create the product
          let product = await ProductsServices.createProduct(p);

          // Invalidate cached brand/supplier lists so the next create/edit form sees new entries
          if (createdNewLookup) {
            clearProductFormLookupsCache();
            await this.loadBrandFilterOptions();
          }

          // 2. Refresh grid page
          await this.loadGridPage();

          // 3. Notify Socket
          socket.emit("propagate", {
            entity: "products",
            action: "create",
            data: product,
          });

          const notice = productFinancaSaveNotice("create", product);
          notify_text = notice.text;
          this.$toast[notice.level](notify_text);

          // 4. Reset form and refresh code (Create and Copy / Create and Stay) - after create so next-code returns new value
          if (onAfterCreate) {
            await onAfterCreate();
          }

          // 5. Handle Closing Logic
          if (close_on_submit) {
            this.form_create = null;
            this.$root.selected_one = {};
          }
        } else {
          const guid = this.selectedProduct?.guid || p.guid;
          if (!guid) {
            throw new Error("Nuk u gjet GUID i produktit. Mbyllni kartelën dhe hapeni përsëri.");
          }
          p.guid = guid;
          let product = await ProductsServices.editProduct(p);

          if (createdNewLookup) {
            clearProductFormLookupsCache();
            await this.loadBrandFilterOptions();
          }

          await this.loadGridPage();
          if (this.selected_item && this.selected_item.guid === product.guid) {
            this.selected_item = { ...this.selected_item, ...product };
          }
          socket.emit("propagate", {
            entity: "products",
            action: "edit",
            data: product,
          });
          const notice = productFinancaSaveNotice("edit", product);
          notify_text = notice.text;
          this.historyReloadKey += 1;
          this.form_edit = null;
          this.$root.selected_one = {};
          this.$toast[notice.level](notify_text);
        }
      } catch (e) {
        console.error("Product save failed", e?.response?.status, e?.response?.data || e);
        const message = this.formatProductSaveError(e);
        this.$toast.error(message);
      } finally {
        this.productSaving = false;
        if (typeof onDone === "function") onDone();
      }
    },
    formatProductSaveError(e) {
      const data = e?.response?.data;
      const status = e?.response?.status;
      const fieldErrors =
        data?.errors && typeof data.errors === "object"
          ? Object.values(data.errors).flat().filter(Boolean)
          : [];
      if (fieldErrors.length) return fieldErrors.join(" ");
      if (data?.message) return data.message;
      if (status === 413) return "Të dhënat janë shumë të mëdha (p.sh. foto). Provoni foto më të vogla.";
      if (status === 419) return "Sesioni ka skaduar. Rifreskoni faqen dhe provoni përsëri.";
      if (status === 401 || status === 403) return "Nuk keni të drejtë ta ruani këtë produkt.";
      if (status >= 500) return data?.message || "Gabim në server gjatë ruajtjes. Shikoni log-et PHP.";
      return e?.message || "Gabim gjatë ruajtjes së produktit. Kontrolloni fotot dhe të dhënat.";
    },
    async submitProductRecipe(pr) {
      if (this.form_create_product_recipe != null) {
        pr.product_id = this.selectedProduct.guid;
        var notify_text = "";
        let p_recipe = await ProductsServices.createProductRecipe(pr);
        var a = this.product_recipes;
        a.push(p_recipe);
        this.product_recipes = [...a];
        notify_text = "Produkti i perbere u krijua me sukses";
        this.form_create = null;
        this.form_create_product_recipe = null;
        this.$root.selected_one = {};
      } else {
        pr.id = this.selectedProductRecipe.id;
        let p_recipe = await ProductsServices.editProductRecipe(pr);
        this.product_recipes = this.product_recipes.map((prc) => {
          if (prc.id == p_recipe.id) prc = { ...p_recipe };
          return prc;
        });
        notify_text = "Produkti i perbere u modifikua me sukses";
        this.form_edit = null;
        this.form_edit_product_recipe = null;
        this.$root.selected_one = {};
      }
      // setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 100);
      this.$toast.success(notify_text);
    },
    openModal(modalName) {
      $vfm.show({
        component: defineAsyncComponent(() => import("./components/" + modalName + "-modal.vue")),
      });
    },
    async services_to_grid() {
      await Api(true)
        .post("product/services_data", {})
        .then((res) => {
          this.service_types_list = res.data.service_types_list;
          this.services_eav_data = res.data.services_eav_data;
        });
    },
    toggle_services_col() {
      this.show_services_col = !this.show_services_col;
      // setTimeout(() => { this.gridApi.sizeColumnsToFit(); }, 100);
    },
    show_brands_krudh(entity) {
      var params = {
        fields: [
          "name:Emri i markes",
          // 'icon:Ikona,*name:Emri',
          // 'description:Pershkrimi'
        ],
        entity: entity,
        columns: ["name:80%"],
        title: "Marka",
      };
      $vfm.show({
        component: defineAsyncComponent(() => import("@/components/krudh-modal.vue")),
        params,
      });
    },
    close_selected_item() {
      this.selected_item = { ...{} };
    },
    onProductFinancaResynced(result) {
      if (!this.selected_item?.id) return;
      const fis = result && result.fis_status != null ? Number(result.fis_status) : null;
      if (fis === 0 || fis === 1) {
        this.selected_item = { ...this.selected_item, fis_status: fis };
      }
    },

    getWarehouseName(guid) {
      return this.warehouses_list.find((w) => w.guid == guid)?.name;
    },
  },
  watch: {
    form_edit(val) {
      if (!val) {
        this.productFormTab = "form";
      }
    },
    formEditGuid(guid, prev) {
      if (guid && guid !== prev) {
        this.productFormTab = "form";
      }
    },
  },
  computed: {
    canSeeProductFormHistory() {
      return !!this.form_edit && this.am_allowed("product.can_see_product_history");
    },
    formEditGuid() {
      return this.form_edit?.guid || this.selectedProduct?.guid || null;
    },
    labelImportExportContext() {
      return {
        product_guids: this.labelImportGuids,
        category_guid: null,
        related_entity: "products",
        include_descendants: false,
      };
    },
    gridColumnLabels() {
      const labels = {};
      this.columnDefs.forEach((col) => {
        const key = col.filterField || col.field;
        if (key && col.headerName) labels[key] = col.headerName;
      });
      labels.status = "Statusi";
      labels.status_filter = "Statusi";
      labels.is_accessory = "Tipi";
      labels.in_web = "Shitet ne Web";
      labels.in_store = "Shitet ne dyqan";
      labels.on_offer = "Ka ofertë aktuale";
      labels.has_offer = "Ka ofertë aktuale";
      labels.new_codes = "Kodet e reja";
      labels.edited_codes = "Kodet e edituara";
      labels.has_stock = "Stoku F5";
      labels.demo_version = "Demo";
      labels.warranty_airbag = "Garanci Airbag";
      labels.delisted = "Delistimi";
      labels.origin = "Direct Exchange";
      return labels;
    },
    columnDefs() {
      const formatNumber = (value) => {
        if (value === null || value === undefined || value === "") return "";
        return numeral(value).format("0,0");
      };
      const hidden = this.hiden_columns;

      return [
        {
          headerName: "",
          field: "actions",
          custom_component: "actions.vue",
          is_custom_component: true,
          resizable: false,
          width: 64,
          minWidth: 56,
          cellRendererParams: this.context,
          pinned: "left",
          hide: hidden.includes("actions"),
        },
        {
          headerName: "Kategoria Prind (niveli 1)",
          resizable: true,
          field: "category_level_1",
          filter: true,
          filterType: "multiselect",
          filterOptions: this.categoryFilterOptions.level1,
          floatingFilter: true,
          sortable: true,
          minWidth: 160,
          hide: hidden.includes("category_level_1"),
        },
        {
          headerName: "Nenkategoria (niveli 2)",
          resizable: true,
          field: "category_level_2",
          filter: true,
          filterType: "multiselect",
          filterOptions: this.categoryFilterOptions.level2,
          floatingFilter: true,
          sortable: true,
          minWidth: 160,
          hide: hidden.includes("category_level_2"),
        },
        {
          headerName: "Nenkategoria (niveli 4) (grup produkti)",
          resizable: true,
          field: "category_product_group",
          filter: true,
          filterType: "multiselect",
          filterOptions: this.categoryFilterOptions.level4,
          floatingFilter: true,
          sortable: true,
          minWidth: 180,
          hide: hidden.includes("category_product_group"),
        },
        {
          headerName: "Tipi",
          resizable: true,
          field: "product_type_label",
          filterField: "is_accessory",
          filterType: "select",
          filterOptions: [
            { value: "0", label: "Produkt" },
            { value: "1", label: "Aksesor" },
          ],
          filter: true,
          floatingFilter: true,
          sortable: true,
          width: 110,
          sortField: "is_accessory",
          hide: hidden.includes("product_type_label"),
        },
        {
          headerName: "Kodi",
          resizable: true,
          field: "code",
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("code"),
        },
        {
          headerName: "Pershkrimi",
          resizable: true,
          field: "name",
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("name"),
        },
        {
          headerName: "Cmimi i dyqanit",
          resizable: true,
          field: "default_price",
          filter: true,
          floatingFilter: true,
          sortable: true,
          cellRenderer: function (params) {
            return "<div class='mr-2 text-right'>" + formatNumber(params.data.default_price) + "</div>";
          },
          hide: hidden.includes("default_price"),
        },
        {
          headerName: "Ka ofertë aktuale",
          resizable: true,
          field: "has_offer_name",
          filterField: "has_offer",
          filterType: "select",
          filterOptions: [
            { value: "1", label: "Po" },
            { value: "0", label: "Jo" },
          ],
          filter: true,
          floatingFilter: true,
          sortable: false,
          width: 120,
          hide: hidden.includes("has_offer_name"),
        },
        {
          headerName: "Cmim ofertë",
          resizable: true,
          field: "price",
          editable: {
            type: "number",
            field: "price",
            modules: {
              operation: true,
              number: true,
              percentage: true,
            },
            value: 0,
          },
          cellRenderer: function (params) {
            return "<div class='mr-2 text-right'>" + formatNumber(params.data.price) + "</div>";
          },
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("price"),
        },
        {
          headerName: "Stoku Financa 5",
          resizable: true,
          field: "erp_stock",
          filter: false,
          floatingFilter: false,
          sortable: false,
          cellRenderer: function (params) {
            return "<div class='mr-2 text-right'>" + formatNumber(params.data.erp_stock) + "</div>";
          },
          hide: hidden.includes("erp_stock"),
        },
        {
          headerName: "Marka",
          resizable: true,
          field: "brand_name",
          filter: true,
          filterType: "multiselect",
          filterOptions: this.brandFilterOptions,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("brand_name"),
        },
        {
          headerName: "Modeli",
          resizable: true,
          field: "model",
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("model"),
        },
        {
          headerName: "Furnitori",
          resizable: true,
          field: "supplier_name",
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("supplier_name"),
        },
        {
          headerName: "Garancia",
          resizable: true,
          field: "warranty_name",
          editable: {
            type: "select",
            options: this.warranties,
            field: "warranty_id",
            value: "__mos_ndrysho__",
            empty: {
              id: "",
              label: "[Nuk ka]",
            },
          },
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("warranty_name"),
        },
        {
          headerName: "Shitet ne Web",
          resizable: true,
          field: "in_web_name",
          filterField: "in_web",
          filterType: "select",
          filterOptions: [
            { value: "1", label: "Po" },
            { value: "0", label: "Jo" },
          ],
          editable: {
            type: "select",
            options: [
              { id: 1, label: "Po" },
              { id: 0, label: "Jo" },
            ],
            field: "in_web",
            value: "__mos_ndrysho__",
            empty: {
              id: "",
              label: "[Pa percaktuar]",
            },
          },
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("in_web_name"),
        },
        {
          headerName: "Shitet ne dyqan",
          resizable: true,
          field: "in_store_name",
          filterField: "in_store",
          filterType: "select",
          filterOptions: [
            { value: "1", label: "Po" },
            { value: "0", label: "Jo" },
          ],
          editable: {
            type: "select",
            options: [
              { id: 1, label: "Po" },
              { id: 0, label: "Jo" },
            ],
            field: "in_store",
            value: "__mos_ndrysho__",
            empty: {
              id: "",
              label: "[Pa percaktuar]",
            },
          },
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("in_store_name"),
        },
        {
          headerName: "Garanci Airbag",
          resizable: true,
          field: "warranty_airbag_name",
          filterField: "warranty_airbag",
          filterType: "select",
          filterOptions: [
            { value: "1", label: "Po" },
            { value: "0", label: "Jo" },
          ],
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("warranty_airbag_name"),
        },
        {
          headerName: "Direct Exchange",
          resizable: true,
          field: "origin_country",
          filterField: "origin",
          filterType: "select",
          filterOptions: this.origin_countries.map((c) => ({
            value: String(c.id || c.code),
            label: c.name || c.label,
          })),
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("origin_country"),
          editable: {
            type: "select",
            options: this.origin_countries,
            field: "origin",
            value: "__mos_ndrysho__",
            empty: {
              id: null,
              label: "[Nuk ka]",
            },
          },
        },
        {
          headerName: "Demo",
          resizable: true,
          field: "demo_version_name",
          filterField: "demo_version",
          filterType: "select",
          filterOptions: [
            { value: "1", label: "Po" },
            { value: "0", label: "Jo" },
          ],
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("demo_version_name"),
        },
        {
          headerName: "Barkodi",
          resizable: true,
          field: "barcode",
          filter: true,
          floatingFilter: true,
          sortable: true,
          hide: hidden.includes("barcode"),
        },
        {
          headerName: "Statusi",
          resizable: true,
          field: "status_name",
          filterField: "status",
          filterType: "select",
          filterOptions: [
            { value: "1", label: "Aktiv" },
            { value: "0", label: "Jo aktiv" },
          ],
          editable: {
            type: "select",
            options: [
              { id: 1, label: "Aktiv" },
              { id: 0, label: "Jo aktiv" },
            ],
            field: "status",
            value: "__mos_ndrysho__",
            empty: {
              id: "",
              label: "[Pa percaktuar]",
            },
          },
          filter: true,
          floatingFilter: true,
          sortable: true,
          sortField: "status",
          hide: hidden.includes("status_name"),
        },
        {
          headerName: "Delistimi",
          resizable: true,
          field: "delisted_name",
          filterField: "delisted",
          filterType: "select",
          filterOptions: [
            { value: "1", label: "Delistuar" },
            { value: "0", label: "Jo delistuar" },
          ],
          editable: {
            type: "select",
            options: [
              { id: 1, label: "Delistuar" },
              { id: 0, label: "Jo delistuar" },
            ],
            field: "delisted",
            value: "__mos_ndrysho__",
            empty: {
              id: "",
              label: "[Pa percaktuar]",
            },
          },
          filter: true,
          floatingFilter: true,
          sortable: true,
          sortField: "delisted",
          hide: hidden.includes("delisted_name"),
        },
      ];
    },
  },
  async created() {
    if (!this.am_allowed("product.can_see_product")) {
      window.location.href = "/home";
    }
    this.localeText = locale.locale_al();

    // Reset stale column visibility / order from previous grid layouts.
    localStorage.removeItem("hiden_columns");
    Object.keys(localStorage)
      .filter((k) => k.startsWith("product-grid") || k.startsWith("dable_layout_product-grid"))
      .forEach((k) => localStorage.removeItem(k));
    this.hiden_columns = [];

    const [originCountries] = await Promise.all([
      ProductServices.getOriginCountries(),
      this.syncCategoryFilterOptions(),
      this.loadBrandFilterOptions(),
    ]);
    this.origin_countries = originCountries;
    await this.loadGridPage();
    this.product_recipes = await ProductsServices.getProductRecipes();
    this.$root.setCurrentRoute("katalog-produkte");
    this.managers = await ProductServices.getManagers();
    this.warranties = await ProductsServices.getWarranties();
    this.warehouses_list = await WarehousesServices.getWarehouses();

    const openGuid = this.$route?.query?.guid;
    const openCode = this.$route?.query?.code;
    if (openGuid || openCode) {
      try {
        let product = null;
        if (openGuid) {
          product = await ProductsServices.get({ guid: openGuid });
        } else if (openCode) {
          const grid = await ProductsServices.getProductsGrid({
            page: 1,
            per_page: 5,
            product_codes: [String(openCode)],
          });
          product = (grid?.data || [])[0] || null;
          if (product?.guid) {
            product = await ProductsServices.get({ guid: product.guid });
          }
        }
        if (product?.guid) {
          // Deep-link from calendar / external: open edit kartela when allowed, else details.
          const mode = this.am_allowed("product.can_edit_product") ? "1" : "0";
          await this.open(mode, product);
        }
      } catch (_) {
        /* ignore deep-link failures */
      }
    }
  },
  onBeforeDestroy() {
    if (this.search_debounce_timer) {
      clearTimeout(this.search_debounce_timer);
    }
    socket.disconnect();
  },
  mounted() {},
};
</script>

<style>
.type_id_name,
.accessory_id_name,
.transportable,
.mountable {
  color: rgb(235, 8, 8);
}

/* grid - form - single structure */
.half-height {
  height: 50vh;
}

.overfllow-y-scroll {
  overflow-y: scroll;
  position: relative;
}

.ag-root-wrapper.ag-layout-normal {
  height: 40vh;
}

@media (max-width: 767px) {
  /* Your styles for screens below 768px width */
  .overfllow-y-scroll-mobile {
    overflow-y: scroll;
  }
}

.group-change-loading {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.45);
}
.group-change-loading__box {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #fff;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e293b;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.2);
}
.group-change-loading__box .fa {
  color: #2563eb;
}

.product-form-tabs {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  padding-top: 0.35rem;
}
.product-form-tabs ul {
  margin-bottom: 0;
  border-bottom-color: #dbdbdb;
}
.product-form-history {
  border: solid 1px #dbdbdb;
  border-top: 0;
  min-height: 12rem;
}
</style>
